module.exports = __webpack_public_path__ + "static/media/one.69bf049a.jpg";